import { PropsWithChildren, ReactNode } from "react";

import Stack from "@/components/stack/stack";

interface MapControlOverlayHeaderProps {
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}

const MapControlOverlayHeader = ({
  children,
  leftIcon,
  rightIcon,
}: PropsWithChildren<MapControlOverlayHeaderProps>) => {
  return (
    <Stack alignItems="center" justifyContent="space-between">
      {leftIcon}
      <div>{children}</div>
      {rightIcon}
    </Stack>
  );
};

export default MapControlOverlayHeader;
